import React from 'react';

import BottomSheet from 'components/DesignSystem/BottomSheet';
import Icon from 'components/DesignSystem/Icon';
import { SortDirection } from 'constants/sorting';
import { IndiceClimaticoField } from 'types/Meteorology/indicesClimaticos';
import { cssVar } from 'constants/theme';
import INDICES from '../indices';

import './index.scss';

export type SortField = IndiceClimaticoField | 'ano';

export interface SortSheetProps {
  open: boolean;
  dismiss: () => void;
  sortField: SortField;
  sortDirection: SortDirection;
  onChange: (field: SortField, direction: SortDirection) => void;
}

const SORT_OPTIONS: { id: SortField; label: string }[] = [
  { id: 'ano', label: 'Ano' },
  ...INDICES.map(({ id, label }) => ({ id, label })),
];

export default function SortSheet({
  open,
  dismiss,
  sortField,
  sortDirection,
  onChange,
}: SortSheetProps) {
  return (
    <BottomSheet open={open} dismiss={dismiss} title="Ordenar por" className="agro-simil-sort-sheet">
      <div className="agro-simil-sort-sheet-body">
        {SORT_OPTIONS.map(({ id, label }) => {
          const active = sortField === id;
          let suffix = '';
          if (active) {
            suffix = sortDirection === 'ASC' ? ' · crescente' : ' · decrescente';
          }
          return (
            <button
              key={id}
              type="button"
              className={`agro-simil-sort-sheet-option${active ? ' active' : ''}`}
              onClick={() => onChange(id, active && sortDirection === 'ASC' ? 'DESC' : 'ASC')}
            >
              <span>
                {label}
                {suffix}
              </span>
              {active && (
                <Icon
                  iconType={sortDirection === 'ASC' ? 'up_arrow' : 'down_arrow'}
                  color={cssVar('text-accent')}
                  size="small"
                />
              )}
            </button>
          );
        })}
      </div>
    </BottomSheet>
  );
}
